import React from "react";
import Report from "./Report";
import TimeSpent from "./TimeSpent";
import Tabs from "../../../CommonComponents/Tabs";

const ReportPage = (props) => {
  const tabItems = [
    {
      label: sessionStorage.getItem("aPathName"),
      content: <Report {...props} />,
    },

    // { label: "Time Spent", content: <TimeSpent /> },
  ];
  return (
    <div className="report-main-container">
      {/* <Tabs tabItems={tabItems} /> */}
      <Report {...props}/>
    </div>
  );
};

export default ReportPage;
